const messageEnumerators = {
  status: [
    'sending',
    'sent',
    'seen',
  ],
}

export default messageEnumerators
